
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 6.333H.667v7.334C.667 14.407 1.26 15 2 15h11.333v-1.333H2V6.333z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12 3.667V2.333C12 1.6 11.4 1 10.667 1H8c-.733 0-1.333.6-1.333 1.333v1.334H3.333V11c0 .733.6 1.333 1.334 1.333H14c.733 0 1.333-.6 1.333-1.333V3.667H12zM8 2.333h2.667v1.334H8V2.333zM14 11H4.667V5H14v6z","fill":"currentColor"}})])
          )
        }
      }
    